import type { EquipmentItem } from '@sb/integrations/types';
import type { ResolvedTCP } from '@sb/integrations/utils';
import { buildEndEffectorChain } from '@sb/integrations/utils';
import type { TCPFrame } from '@sb/motion-planning';

/**
 * The single flange→TCP answer for a frame, resolved through
 * `EndEffectorChain` — the ordered wrist-chain model that owns the
 * resolution rules (id-wins-when-publishing, single-enabled-owner,
 * ambiguity/legacy/stale-index degrade to the flange, chain members answer
 * `tool0` with the composed sensor-face pose).
 *
 * Callers that need the ROS link take `tcpLink`; callers that need the pose
 * (or just its rotation) take `transformFromTool0`. One resolve spine means
 * the link and the transform cannot drift apart.
 */
export function resolveTCPFrame(
  equipmentItems: EquipmentItem[],
  frame: TCPFrame,
): ResolvedTCP {
  return buildEndEffectorChain(equipmentItems).tcp(frame);
}
